export const SERVICE_DATA = [
  {
    slug: 'school-uniforms',
    name: 'School Uniforms',
    tagline: 'Outfitting Students for Success',
    shortDescription: 'High-quality, durable school uniforms that promote unity and pride among students.',
    description: `Kre8ing Your IdeaS is a trusted partner school uniform provider serving over 20 schools across the Baltimore-Washington metro area. We understand that school uniforms are more than just clothing — they foster a sense of community, equality, and school pride.

Our uniforms are built to last through the wear and tear of everyday school life, using premium fabrics that hold up wash after wash. Every piece is professionally finished with precise embroidery of your school's logo and colors.`,
    callout: 'Bring your own shirt for just $15 — we\'ll add the embroidery!',
    image: '/images/school-uniforms/school-uniform-02.jpeg',
    gallery: [
      {
        src: '/images/school-uniforms/school-uniform-08.jpeg',
        alt: 'Students wearing matching school uniforms — black BJA cardigans, white shirts, bow ties, and navy bottoms',
        caption: 'Full uniform sets — black cardigans with embroidered school logo and bow-tie accents',
      },
      {
        src: '/images/school-uniforms/school-uniform-10.jpeg',
        alt: 'Stacked maroon and yellow polos and a maroon zip jacket embroidered with Northwest Academy of Health Sciences logo',
        caption: 'Northwest Academy of Health Sciences — maroon and gold uniform program',
      },
      {
        src: '/images/school-uniforms/school-uniform-02.jpeg',
        alt: 'Royal blue and white polo shirts embroidered with the Sudbrook Magnet Middle School logo',
        caption: 'Sudbrook Magnet Middle School — embroidered polo program in school colors',
      },
      {
        src: '/images/school-uniforms/school-uniform-09.jpeg',
        alt: 'Navy, black, and white t-shirts each embroidered with the Sudbrook Magnet Middle School script logo',
        caption: 'Spirit-wear tees with cursive Sudbrook lettering in yellow and pink',
      },
      {
        src: '/images/school-uniforms/school-uniform-14.jpeg',
        alt: 'Black Sudbrook Magnet Middle School polo shirts and matching long-sleeve sweatshirt with white embroidery',
        caption: 'Coordinated black polos and sweatshirt for staff and spirit days',
      },
      {
        src: '/images/school-uniforms/school-uniform-12.jpeg',
        alt: 'Navy polos and a brown quarter-zip embroidered with Sudbrook logo plus the personalized name "Darsh"',
        caption: 'Personalized uniforms with student names embroidered alongside the school logo',
      },
      {
        src: '/images/school-uniforms/school-uniform-05.jpeg',
        alt: 'Stack of navy and grey Coppin State University Nike polos with the CSU eagle emblem',
        caption: 'College spirit polos — Coppin State University in Nike performance fabric',
      },
      {
        src: '/images/school-uniforms/school-uniform-07.jpeg',
        alt: 'Orange crewneck sweatshirts with a bold navy and white block letter K logo',
        caption: 'Bright orange spirit sweatshirts with bold block-letter school monogram',
      },
      {
        src: '/images/school-uniforms/school-uniform-11.jpeg',
        alt: 'Group of students and adults wearing matching purple sweatshirts with a green and white school logo',
        caption: 'Group spirit sweatshirts — outfitting an entire class for a school event',
      },
      {
        src: '/images/school-uniforms/school-uniform-13.jpeg',
        alt: 'Navy and orange Frederick Douglass High School letterman jacket with embroidered mascot, crest, and class of 1966 details',
        caption: 'Commemorative letterman jacket — Frederick Douglass High School, Baltimore',
      },
    ],
    features: [
      'Partner school polo shirts & bottoms',
      'Bring your own shirt embroidery ($15)',
      'Bulk order pricing for schools',
      'PE & Spirit wear customization',
      'Consistent sizing & quality',
      'Quick turnaround for back-to-school',
    ],
    process: [
      { step: '01', title: 'Choose Your School', desc: 'Select from our list of 20+ partner schools or contact us to add yours.' },
      { step: '02', title: 'Pick Styles & Sizes', desc: 'Browse available polo colors, sizes, and optional extras like jackets or sweaters.' },
      { step: '03', title: 'We Embroider & Ship', desc: 'Your school logo is precisely stitched and items ship directly to you.' },
    ],
    intentCategory: 'school-uniforms',
    relatedCategories: ['school-uniforms'],
  },
  {
    slug: 'greek-apparel',
    name: 'Greek Apparel',
    tagline: 'Represent Your Letters with Pride',
    shortDescription: 'Custom fraternity and sorority gear — from crossing jackets to line jerseys.',
    description: `Whether you're crossing the burning sands, celebrating Founders' Day, or just repping your organization around campus, KYIS creates premium Greek letter apparel that stands out.

We work with all Divine Nine organizations and other Greek-letter groups to produce custom stitched hoodies, line jackets, crossing gear, and accessories. Every piece is made with care, using high-quality twill and embroidery that lasts for years.`,
    callout: 'Custom crossing jackets and line numbers — designed with your chapter in mind.',
    image: '/images/greek-apparel/royal-blue-jacket-tee-set.jpeg',
    gallery: [
      {
        src: '/images/greek-apparel/red-white-greek-totes.jpeg',
        alt: 'Four red and white canvas tote bags with embroidered Greek letters and chapter details',
        caption: 'Custom chapter totes with embroidered letters and member names',
      },
      {
        src: '/images/greek-apparel/royal-blue-jacket-tee-set.jpeg',
        alt: 'Royal blue half-zip jacket and matching t-shirt with white Greek-letter embroidery',
        caption: 'Matching jacket and tee with chapter year and line embroidery',
      },
      {
        src: '/images/greek-apparel/personalized-line-sister-bag.jpeg',
        alt: 'Member holding a red sorority tote bag personalized with line name and Greek letters',
        caption: 'Personalized line-sister tote in chapter colors',
      },
      {
        src: '/images/greek-apparel/purple-gold-fur-pillows.jpeg',
        alt: 'Black faux fur pillows with embroidered Greek letters and a chapter crest in purple and metallic gold',
        caption: 'Faux fur accent pillows with metallic-thread crest embroidery',
      },
      {
        src: '/images/greek-apparel/green-pink-chapter-jacket.jpeg',
        alt: 'Green coach jacket embroidered with pink Greek letters, chapter name, and member details',
        caption: 'Full chapter jacket with personalized embroidery details',
      },
      {
        src: '/images/greek-apparel/velvet-quarter-zip-set.jpeg',
        alt: 'Royal blue velvet quarter-zip pullovers with white embroidered fraternity crest',
        caption: 'Premium velvet quarter-zips with embroidered fraternity crest',
      },
      {
        src: '/images/greek-apparel/pledge-line-blanket.jpeg',
        alt: 'Red commemorative pledge-line blanket with embroidered list of member names and Greek letters',
        caption: 'Commemorative pledge-line blanket with full roster',
      },
      {
        src: '/images/greek-apparel/green-yellow-merchandise-set.jpeg',
        alt: 'Chapter merchandise set including chair, tote bag, denim jacket, and pouches in green and yellow',
        caption: 'Full chapter merchandise set — jacket, tote, chair, and pouches',
      },
    ],
    features: [
      'Fraternity & sorority lettering',
      'Crossing jackets & line jackets',
      'Stitched letters (twill & embroidery)',
      'Custom Greek accessories',
      'Probate & reveal apparel',
      'Chapter bulk order discounts',
    ],
    process: [
      { step: '01', title: 'Tell Us Your Org', desc: 'Share your organization, chapter, and line details.' },
      { step: '02', title: 'Design Together', desc: 'We\'ll create a mockup with your letters, colors, and any custom graphics.' },
      { step: '03', title: 'Stitch & Deliver', desc: 'Precision stitching, quality inspection, and delivery right to your door.' },
    ],
    intentCategory: 'greek-apparel',
    relatedCategories: ['greek-apparel'],
  },
  {
    slug: 'business-branding',
    name: 'Business Branding',
    tagline: 'Elevate Your Professional Image',
    shortDescription: 'Professional embroidery for uniforms, promotions, and corporate identity.',
    description: `Your team's appearance speaks volumes about your brand. KYIS helps businesses of all sizes create a polished, professional look through custom-embroidered uniforms, promotional products, and branded merchandise.

From a single employee polo to outfitting an entire workforce, we handle logo digitization, color matching, and consistent production so every piece represents your brand perfectly. We serve restaurants, salons, construction companies, medical offices, and more.`,
    callout: 'Free logo digitization with orders of 12 pieces or more.',
    image: '/images/business-branding/shaw-bucket-hats.jpeg',
    gallery: [
      {
        src: '/images/business-branding/umms-car-organizers.jpeg',
        alt: 'University of Maryland Medical System branded car organizers with embroidered patches',
        caption: 'Embroidered patches on branded accessories — University of Maryland Medical System',
      },
      {
        src: '/images/business-branding/clearview-autoglass-shorts.jpeg',
        alt: 'Tan and grey chino shorts with the Clearview Autoglass logo embroidered on the leg',
        caption: 'Custom-embroidered uniforms — Clearview Autoglass',
      },
      {
        src: '/images/business-branding/shaw-bucket-hats.jpeg',
        alt: 'Navy and black bucket hats with the gold Shaw logo embroidered on the front',
        caption: 'Branded headwear with metallic gold embroidery — Shaw',
      },
      {
        src: '/images/business-branding/parentchild-table-cover.jpeg',
        alt: 'Light blue fitted trade-show table cover with the ParentChild logo and tagline',
        caption: 'Trade-show table covers and event branding — ParentChild',
      },
    ],
    features: [
      'Company uniform programs',
      'Logo digitization & setup',
      'Promotional products & swag',
      'Corporate gift sets',
      'Trade show & event apparel',
      'Consistent brand standards',
    ],
    process: [
      { step: '01', title: 'Share Your Logo', desc: 'Send us your logo file or a photo — we\'ll digitize it for embroidery.' },
      { step: '02', title: 'Choose Your Items', desc: 'Pick from polos, jackets, caps, bags, and more for your team.' },
      { step: '03', title: 'Branded & Ready', desc: 'Professional embroidery applied and quality-checked before delivery.' },
    ],
    intentCategory: 'business-branding',
    relatedCategories: ['business-branding'],
  },
  {
    slug: 'personalized-gifts',
    name: 'Personalized Gifts',
    tagline: 'Thoughtful Gifts They\'ll Treasure',
    shortDescription: 'Custom embroidered items perfect for any occasion — birthdays, weddings, baby showers.',
    description: `Nothing says "I thought of you" quite like a personalized gift. At KYIS, we create custom-embroidered keepsakes for life's biggest moments — baby showers, weddings, graduations, holidays, and everything in between.

From monogrammed blankets and robes to custom tote bags and stuffed animals, every gift is crafted with attention to detail and delivered with care. We also offer gift wrapping and custom packaging for that extra-special presentation.`,
    callout: 'Ask about our custom gift boxes — perfect for corporate gifting and bridal parties!',
    image: '/images/personalized-gifts/personalized-gift-01.jpeg',
    gallery: [
      {
        src: '/images/personalized-gifts/personalized-gift-05.jpeg',
        alt: 'Three purple Baltimore Ravens tailgate chairs with gold-embroidered team branding and personalized names',
        caption: 'Personalized Ravens tailgate chairs — gold-embroidered names for each fan',
      },
      {
        src: '/images/personalized-gifts/personalized-gift-08.jpeg',
        alt: 'Metallic silver puffed Kate Spade tote bag with a green, pink, and gold sorority crest reading "Silver Star" and "Soror Tammie"',
        caption: 'Personalized sorority tote — embroidered crest on a quilted Kate Spade bag',
      },
      {
        src: '/images/personalized-gifts/personalized-gift-03.jpeg',
        alt: 'Pink low-top Converse sneakers personalized with black embroidered hearts and "Mrs. Hullmann" on the tongue',
        caption: 'Personalized bridal sneakers — embroidered hearts and married name',
      },
      {
        src: '/images/personalized-gifts/personalized-gift-01.jpeg',
        alt: 'Stacks of white bath towels embroidered with the names "Brian" and "Adriana" in metallic bronze cursive script',
        caption: 'His-and-hers white towel set with bronze cursive name embroidery',
      },
      {
        src: '/images/personalized-gifts/personalized-gift-02.jpeg',
        alt: 'Stack of dark grey towels embroidered in purple and white with pastor names and a small bible graphic',
        caption: 'Pastor appreciation towel set — personalized purple embroidery with bible motif',
      },
      {
        src: '/images/personalized-gifts/personalized-gift-04.jpeg',
        alt: 'Blue hand towel with a guitar and "Jeremy, The Bass Player" beside a brown hand towel with a drum kit and "J. Caesar, Da Drummer"',
        caption: 'Music-themed personalized hand towels with instrument graphics',
      },
      {
        src: '/images/personalized-gifts/personalized-gift-06.jpeg',
        alt: 'Black baby onesie embroidered in white with "little answered prayer" and three children\'s names and birth dates',
        caption: 'Sentimental baby onesie — "little answered prayer" with sibling names and dates',
      },
      {
        src: '/images/personalized-gifts/personalized-gift-07.jpeg',
        alt: 'Front and back of a black mesh sports jersey with graffiti-style "ELITE" lettering and "GRITY" name with number 9',
        caption: 'Custom graffiti-style sports jersey with personalized name and number',
      },
    ],
    features: [
      'Baby blankets & onesies',
      'Wedding & bridal party gifts',
      'Monogrammed robes & towels',
      'Custom tote bags & pouches',
      'Holiday & seasonal items',
      'Gift wrapping available',
    ],
    process: [
      { step: '01', title: 'Pick Your Item', desc: 'Choose from our catalog or bring your own item for personalization.' },
      { step: '02', title: 'Personalize It', desc: 'Add names, dates, monograms, or custom messages.' },
      { step: '03', title: 'Gift-Ready', desc: 'Beautifully embroidered and packaged for the perfect gift.' },
    ],
    intentCategory: 'personalized-gifts',
    relatedCategories: ['personalized-gifts'],
  },
  {
    slug: 'graduations',
    name: 'Graduations',
    tagline: 'Celebrate the Achievement',
    shortDescription: 'Custom caps, stoles, sashes, and celebratory apparel for your milestone.',
    description: `Graduation is a once-in-a-lifetime moment — make it unforgettable with custom graduation apparel from KYIS. We create personalized stoles, sashes, caps, and celebratory t-shirts that honor your hard work and achievement.

Whether it's pre-K, high school, or a doctoral ceremony, we'll help you design pieces that you, your family, and your friends will cherish. Our graduation gear is perfect for individuals, organizations, and schools.`,
    callout: 'Order early for the best turnaround — graduation season fills up fast!',
    image: '/images/graduations/graduation-01.jpeg',
    gallery: [
      {
        src: '/images/graduations/graduation-02.jpeg',
        alt: 'Orange Morgan State graduation stole with navy embroidered class of 2022, mascot bear, and computer science degree details',
        caption: 'Morgan State Class of 2022 stole — major, mascot, and personalized monogram',
      },
      {
        src: '/images/graduations/graduation-01.jpeg',
        alt: 'Navy blue graduation cap with gold trim embroidered with "The Tassel Was Worth the Hassle" and nursing icons',
        caption: 'Nursing grad cap — embroidered medical icons and inspirational tassel quote',
      },
      {
        src: '/images/graduations/graduation-03.jpeg',
        alt: 'Black graduation cap embroidered in red and white with an EKG line, RN initials, and Class of 2022',
        caption: 'RN Class of 2022 grad cap with EKG line and "Delayed but Never Denied" message',
      },
      {
        src: '/images/graduations/graduation-05.jpeg',
        alt: 'Royal blue Nike backpack embroidered in gold thread with "Coach Cuc" and "Class of 2026"',
        caption: 'Personalized grad gift backpack — gold embroidered coach name and class year',
      },
      {
        src: '/images/graduations/graduation-04.jpeg',
        alt: 'Royal blue Phi Beta Sigma hoodies and a black coach jacket embroidered with Greek letters and fraternity crest',
        caption: 'Phi Beta Sigma grad apparel set — embroidered Greek letters and chapter crest',
      },
    ],
    features: [
      'Custom embroidered stoles',
      'Personalized sashes & cords',
      'Decorated graduation caps',
      'Class year t-shirts & hoodies',
      'Group photo matching apparel',
      'Organization & honor society gear',
    ],
    process: [
      { step: '01', title: 'Tell Us About Your Milestone', desc: 'Share your school, degree, and any org affiliations.' },
      { step: '02', title: 'Design Your Pieces', desc: 'We\'ll create a custom design with your colors, year, and details.' },
      { step: '03', title: 'Walk the Stage in Style', desc: 'Receive your custom grad gear — ready for the big day.' },
    ],
    intentCategory: 'graduations',
    relatedCategories: ['graduations'],
  },
  {
    slug: 'custom-embroidery',
    name: 'Custom Embroidery',
    tagline: 'Precision Stitching for Any Design',
    shortDescription: 'Professional embroidery for logos, names, and custom artwork on any garment.',
    description: `Custom embroidery is the heart of what we do at KYIS. With over 30 years of experience, our team delivers precise, vibrant stitching on virtually any fabric — from polos and jackets to bags and blankets.

We handle everything from simple name personalization to complex multi-color logo embroidery. Our in-house digitizing team converts your artwork into stitch-ready files, ensuring every design looks sharp and professional.`,
    callout: 'Bring your own garment — we\'ll embroider it for you!',
    image: '/images/custom-embroidery/hero.jpeg',
    gallery: [
      {
        src: '/images/custom-embroidery/dance-team-tees.jpeg',
        alt: 'Black t-shirts custom embroidered with a dance team mascot graphic and personalized name',
        caption: 'Custom team shirts with mascot artwork + personalized names',
      },
      {
        src: '/images/custom-embroidery/team-crop-tops.jpeg',
        alt: 'Group wearing matching black crop tops with a gold diamond emblem',
        caption: 'Matching team uniforms with metallic gold embroidery',
      },
      {
        src: '/images/custom-embroidery/waffle-knit-blanket.jpeg',
        alt: 'Grey waffle-knit blanket with a yellow embroidered inspirational quote',
        caption: 'Inspirational quote stitched onto a waffle-knit throw blanket',
      },
      {
        src: '/images/custom-embroidery/denim-vest-business.jpeg',
        alt: 'Distressed denim vest with a custom business logo embroidered on the back',
        caption: 'Branded denim vest with full-back logo embroidery',
      },
      {
        src: '/images/custom-embroidery/university-blanket.jpeg',
        alt: 'Red fringed fleece blanket embroidered with the Catholic University of America wordmark',
        caption: 'University fan blanket with arched wordmark embroidery',
      },
      {
        src: '/images/custom-embroidery/fitness-brand-tees.jpeg',
        alt: 'Stack of four colorful t-shirts with the Torn 2 B Fit fitness brand graphic',
        caption: 'Multi-color brand apparel run for a fitness business',
      },
    ],
    features: [
      'Logo embroidery & digitization',
      'Name & monogram stitching',
      'Multi-color & gradient designs',
      'Left chest, back, and cap embroidery',
      'Bring-your-own-garment welcome',
      'Small & large batch orders',
    ],
    process: [
      { step: '01', title: 'Send Your Design', desc: 'Share your logo, text, or artwork — any format works.' },
      { step: '02', title: 'We Digitize & Proof', desc: 'Our team converts your design to embroidery and sends a digital proof.' },
      { step: '03', title: 'Stitch Perfection', desc: 'Approved designs are stitched with precision and shipped to you.' },
    ],
    intentCategory: 'custom-embroidery',
    relatedCategories: ['custom-embroidery'],
  },
  {
    slug: 'dtg-printing',
    name: 'Direct to Garment Printing',
    tagline: 'Full-Color Freedom',
    shortDescription: 'Vibrant, photo-realistic prints directly on fabric — no minimums.',
    description: `Direct-to-Garment (DTG) printing brings your full-color designs to life with incredible detail and soft hand feel. Unlike traditional screen printing, DTG allows for unlimited colors and photo-realistic images without setup fees or high minimums.

Perfect for custom one-offs, small batch runs, or designs with complex gradients and photographic elements. Our state-of-the-art DTG printers deliver rich, durable prints that stay vibrant wash after wash.`,
    callout: 'No minimums — print just one shirt or a hundred.',
    image: '/images/custom-embroidery/fitness-brand-tees.jpeg',
    features: [
      'Unlimited colors per design',
      'Photo-realistic image printing',
      'No minimum order quantity',
      'Soft hand feel (ink absorbs into fabric)',
      'Quick turnaround times',
      'Ideal for complex or gradient designs',
    ],
    process: [
      { step: '01', title: 'Upload Your Design', desc: 'Send a high-resolution image or let us create one for you.' },
      { step: '02', title: 'Proof & Approve', desc: 'We\'ll send a digital mockup for your approval before printing.' },
      { step: '03', title: 'Print & Ship', desc: 'Your design is printed with precision and delivered fast.' },
    ],
    intentCategory: 'dtg-printing',
    relatedCategories: ['dtg-printing'],
  },
];

export const getServiceBySlug = (slug) => SERVICE_DATA.find(s => s.slug === slug);
